import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetCountriesAvaliableCommand extends IRequestCommand<
  IGetCountriesResponse,
  ErrorDetails,
  IGetCountriesCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _replaceDefaultHeader = true;
  override _canAddCustomHeaders = false;
  override _needAuthenticate = false;

  public override setParameters(parameters: IGetCountriesCommandParameters) {
    this.urlSections.push('multiregion');
    this.urlSections.push('countries');
    //this.paramsSections.push(`name=${parameters.terms}`);
    this.composeUrl();
  }
}

export interface IGetCountriesCommandParameters extends ICommandParameters {
  terms: string;
}

export interface IGetCountriesResponse extends ICommandResponse {}
